const URL = {
  MCP_CONNECTIONS: 'mcp-connections',
  MCP_CONNECTION_BY_TOOL: 'mcp-connections/{tool}',
}

export default URL
